import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface IProps {
  children: ReactNode;
}

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${p => p.theme.paddingXS}px;
  padding: ${p => p.theme.paddingXS}px 0;
`;

const TranscriptLinesLayout: FC<IProps> = ({ children }) => {

  return <OuterContainer>
    {children}
  </OuterContainer>;
};

export default TranscriptLinesLayout;